import {
	GET_PRICE_GROUPS_SUCCESS,
	GET_PRICE_GROUPS_FAIL,
	CREATE_PRICE_GROUP_SUCCESS,
	UPDATE_PRICE_GROUP_SUCCESS,
	DELETE_PRICE_GROUP_SUCCESS,
} from '../actions/index';

const initialState = {
	groups: [],
	loading: true,
};

const priceGroupReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_PRICE_GROUPS_SUCCESS:
			return { ...state, groups: action.payload, loading: false };
		case GET_PRICE_GROUPS_FAIL:
			return { ...state, groups: [], loading: false };
		case CREATE_PRICE_GROUP_SUCCESS:
			return { ...state, groups: [...state.groups, action.payload] };
		case UPDATE_PRICE_GROUP_SUCCESS:
			return {
				...state,
				groups: state.groups.map((g: any) =>
					g.id === action.payload.id ? { ...g, ...action.payload } : g
				),
			};
		case DELETE_PRICE_GROUP_SUCCESS:
			return {
				...state,
				groups: state.groups.filter((g: any) => g.id !== action.payload),
			};
		default:
			return state;
	}
};

export default priceGroupReducer;
